import { render, staticRenderFns } from "./gostatistics.vue?vue&type=template&id=3cd2efea&scoped=true&"
import script from "./gostatistics.vue?vue&type=script&lang=js&"
export * from "./gostatistics.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=3cd2efea&lang=scss&scoped=true&"
import style1 from "./gostatistics.vue?vue&type=style&index=1&id=3cd2efea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd2efea",
  null
  
)

export default component.exports